import React from 'react'
import {
  Box,
  Button,
  Grid2 as Grid,
  TextField,
  Typography
} from '@mui/material'
import {
  Add as AddIcon,
  InfoOutlined as InfoOutlinedIcon
} from '@mui/icons-material'

interface NewExceptionFormProps {
  newExceptionDate: string
  newExceptionDescription: string
  isSaving: boolean
  onDateChange: (value: string) => void
  onDescriptionChange: (value: string) => void
  onAdd: () => void
}

export const NewExceptionForm: React.FC<NewExceptionFormProps> = ({
  newExceptionDate,
  newExceptionDescription,
  isSaving,
  onDateChange,
  onDescriptionChange,
  onAdd
}) => (
  <>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        bgcolor: '#E8F0FE',
        border: '1px solid',
        borderColor: 'primary.light',
        borderRadius: 1,
        p: 1.5,
        mb: 2
      }}
    >
      <InfoOutlinedIcon color='primary' fontSize='small' sx={{ mt: 0.3 }} />
      <Typography variant='body2'>
        <b>
          Las fechas configuradas reemplazarán la programación normal de
          recolección para ese día.
        </b>{' '}
        Puedes agregar horarios específicos para habilitar la recolección o
        dejar la fecha sin horarios.{' '}
        <b>
          Si no se agrega ningún horario, la recolección quedará bloqueada
          durante todo el día.
        </b>
      </Typography>
    </Box>

    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid size={{ xs: 12, sm: 4 }}>
        <TextField
          fullWidth
          type='date'
          variant='outlined'
          label='Fecha'
          value={newExceptionDate}
          onChange={(e) => onDateChange(e.target.value)}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 5 }}>
        <TextField
          fullWidth
          variant='outlined'
          label='Descripción'
          placeholder='ej: Navidad, Año Nuevo'
          value={newExceptionDescription}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <Button
          fullWidth
          variant='contained'
          color='primary'
          sx={{ height: 56, whiteSpace: 'nowrap' }}
          startIcon={<AddIcon fontSize='small' />}
          disabled={
            isSaving || !newExceptionDate || !newExceptionDescription.trim()
          }
          onClick={onAdd}
        >
          Agregar
        </Button>
      </Grid>
    </Grid>
  </>
)
